import {Badge, Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, DropdownSection} from "@nextui-org/react";
import React, {useEffect, useState} from "react";
import {FaShoppingCart} from "react-icons/fa";
import {useVending} from "./VendingProvider";
import {ShoppingItem} from "./ShoppingItem";
import Cookies from "universal-cookie";

const ShoppingCart = () => {
    const {cart, setCart, openQR, onOpen} = useVending();
    const [total, setTotal] = useState(0);
    useEffect(() => {
        var price = 0;
        cart.forEach((i) => {
            price += i.price * i.amount;
        })
        setTotal(price);
    }, [cart]);

    function DeletedItem(index) {
        const cookies = new Cookies();
        const updatedCart = cart.filter((_, i) => i !== index);
        setCart(updatedCart);
        cookies.set("cart", updatedCart);
    }

    function CompletedBuy(){
        onOpen();
        openQR();
    }

    return (
        <Badge content={cart.length} color={cart.length === 0 ? "danger" : "success"}>
            <Dropdown>
                <DropdownTrigger>
                    <Button isIconOnly color="transparent" className="text-2xl" isDisabled={cart.length <= 0}>
                        <FaShoppingCart/>
                    </Button>
                </DropdownTrigger>
                <DropdownMenu title="Items">
                    <DropdownSection title="Carrito" showDivider>
                        {
                            cart.map((item, index) => (
                                <DropdownItem key={index} isReadOnly>
                                    <ShoppingItem title={item.name} amount={item.amount}
                                                  total={item.price}
                                                  deleteItem={() => DeletedItem(index)}/>
                                </DropdownItem>))
                        }

                    </DropdownSection>
                    <DropdownSection title="Total">
                        <DropdownItem className="text-right text-success" isReadOnly><b
                            className="text-2xl">Gs. {total}</b></DropdownItem>
                        <DropdownItem key="buying" isReadOnly className="text-center" >
                            <Button className="text-right mt-5 text-xl"
                                    color="warning"
                                    isDisabled={cart.length === 0}
                                        onPress={() => CompletedBuy()}><b>Finalizar compra</b></Button>


                        </DropdownItem>
                    </DropdownSection>
                </DropdownMenu>
            </Dropdown>
        </Badge>
    )
};

export default ShoppingCart;